const labelFor = (segment) => {
  if (segment.speaker_label) return String(segment.speaker_label);
  if (['customer', 'user', 'caller'].includes(segment.speaker)) return 'Kunde';
  if (['agent', 'assistant'].includes(segment.speaker)) return segment.actor_id || 'Mitarbeiter';
  return segment.speaker !== undefined ? `Sprecher ${segment.speaker}` : '';
};

export const callTranscriptTurns = (segments, text = '') => {
  if (Array.isArray(segments) && segments.some(segment => segment?.text?.trim())) {
    const turns = [];
    segments.filter(segment => segment?.text?.trim()).forEach(segment => {
      const label = labelFor(segment);
      const key = String(segment.speaker ?? label);
      const last = turns[turns.length - 1];
      if (last && last.key === key && last.label === label) last.text += ` ${segment.text.trim()}`;
      else turns.push({ key, label, text: segment.text.trim() });
    });
    return turns;
  }
  // Keep old text intact. Speaker identities require recorded evidence.
  return String(text || '').split(/\n+/).map(line => line.trim()).filter(Boolean)
    .map((line, index) => ({ key: `legacy-${index}`, label: '', text: line }));
};
